import prepaidCardImageQueries from '@apis/queries/prepaidCardImageQueries';
import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { useQuery } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { nameAtom } from '../../atoms/purchasePrepaidCardAtoms';

interface Props {
    prepaidCardImageId: string;
}

function Summary({ prepaidCardImageId }: Props) {
    const { t } = useTranslation('prepaidCard');
    const { data } = useQuery(prepaidCardImageQueries.detail(prepaidCardImageId));
    const setName = useSetAtom(nameAtom);

    useEffect(() => {
        if (data?.title) {
            setName(data.title);
        }
    }, [data?.title, setName]);

    return (
        <Wrapper>
            <Row spacing={4} align='center' fullWidth>
                <CardImage src={data?.imageUrl}
                    width={90}
                    height={60}
                    alt={t('image.cardImageAlt')} />
                <Column spacing={1}>
                    <Text size='title' fontWeight='bold' multiline>
                        {data?.title}
                    </Text>
                    <Text size='body-short' fontWeight='regular' multiline>
                        {t('image.registerNewCard')}
                    </Text>
                </Column>
            </Row>
        </Wrapper>
    );
}

const Wrapper = styled.section`
    background-color: var(--color-white);
    padding: var(--spacing-4);
    width: 100%;
`;

const CardImage = styled(Image)`
    border-radius: 8px;
    flex-shrink: 0;
    object-fit: cover;
`;

export default Summary;
